import { createSelector } from '@ngrx/store';
import { getRoles } from 'src/app/shared/selectors/roles.selectors';
import { getDragonflyState } from '../reducers';

export const getTagManagementState = createSelector(getDragonflyState, (state) => state.tagManagement);

export const getPanelExpansion = createSelector(getTagManagementState, ({ panelExpanded }) => panelExpanded);

export const getTagTypeSelectionValues = createSelector(getTagManagementState, ({ tagTypeValues }) => tagTypeValues);

export const getTagType = createSelector(getTagManagementState, ({ tagType }) => tagType);

export const getTagCode = createSelector(getTagManagementState, ({ tagCode }) => tagCode);

export const getTagLabel = createSelector(getTagManagementState, ({ tagLabel }) => tagLabel);

export const getSearchRole = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('tags.search') ? true : false,
);

export const getCreateNewButtonDisabled = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('tags.create') ? false : true,
);

export const getSearchButtonDisabled = createSelector(getTagType, getSearchRole, (tagType, searchRole) =>
  tagType === '' || searchRole === false ? true : false,
);
